import { mapNumberFormatToLocale } from '../actions/get-localization.action';
import { LOCALIZATION_DEFAULT_LOCALE } from '../configuration/localization';
import { ILocalizationState } from './../states/localization-state';
import { CultureInfoFormatter } from '@msdyn365-commerce/core';

/**
 *  Get the formatted currency.
 * @param localizationState - localizationState that holds the users preferred format
 * @param currency - currency to display
 * @param price - amount to display
 * @returns The formatted currency as selected in user preferences
 */
export const formatCurrency = (localizationState: ILocalizationState, currency: string | undefined, price: number | undefined): string => {
    if (price === undefined || currency === undefined) {
        return '';
    }

    if (localizationState.numberLocale === undefined) {
        const cultureInfoFormatter = new CultureInfoFormatter(LOCALIZATION_DEFAULT_LOCALE, currency);
        return cultureInfoFormatter.formatCurrency(price);
    } else {
        const cultureInfoFormatter = new CultureInfoFormatter(mapNumberFormatToLocale(localizationState.numberLocale), currency);
        return cultureInfoFormatter.formatCurrency(price);
    }
};
